// eslint-disable-next-line no-shadow
export enum QuizPermissions {
  PUBLISH_QUIZ_LIVE = 'admin.coursebuilder.quiz.live.publish',
  SETUP_QUIZ = 'admin.coursebuilder.quiz.setup',
  EDIT_FEEDBACK = 'admin.coursebuilder.quiz.feedback.edit',
  EDIT_QUESIONS = 'admin.coursebuilder.questions.edit',
}
